import { render, staticRenderFns } from "./HitPhoneWidget.vue?vue&type=template&id=22147f59&scoped=true&"
import script from "./HitPhoneWidget.vue?vue&type=script&lang=js&"
export * from "./HitPhoneWidget.vue?vue&type=script&lang=js&"
import style0 from "./HitPhoneWidget.vue?vue&type=style&index=0&id=22147f59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22147f59",
  null
  
)

export default component.exports